import { render, staticRenderFns } from "./TrangDanhSachDonVi.vue?vue&type=template&id=7e757dba&"
import script from "./TrangDanhSachDonVi.vue?vue&type=script&lang=js&"
export * from "./TrangDanhSachDonVi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports